// The 13th month basis (PRD_ThirteenthMonthPay C4) — which pay components count
// as "basic salary" for PD 851.
//
// Same factor keys and labels as the SSS/PhilHealth contribution bases
// (SSS_BASIS_FACTORS), different DEFAULTS: the Revised Guidelines on the 13th
// Month Pay Law (DOLE, 16 Nov 1987) §4a exclude "overtime, premium, night
// differential and holiday pay" from basic salary, and the DOLE-BWC Handbook's
// worked example subtracts unpaid days — so every add-on starts OFF and both
// subtractions start ON. Ticking an add-on is §4a's "company practice or
// policy" clause, so every combination is lawful.
//
// ONE normaliser for both readers — the Payroll Rates card and the generator.
// A company that never saved Payroll Rates has no stored value, and reading it
// as falsy would stop subtracting absences (the SSS C19 trap).

import { SSS_BASIS_FACTORS } from "./sssBasisFactors";

export const THIRTEENTH_MONTH_BASIS_FACTORS = SSS_BASIS_FACTORS;

export const DEFAULT_THIRTEENTH_MONTH_BASIS = {
  factors: {
    basic: true,
    overtime: false,
    nightDiff: false,
    holiday: false,
    restDay: false, // add
    undertime: true,
    absence: true, // subtract
  },
};

/**
 * Missing key → its default, present key → a literal boolean, `basic` forced
 * true, unknown keys dropped.
 *
 * @param {?Object} stored - `settings/payrollRates.thirteenthMonthBasis`, possibly partial or absent.
 * @returns {{factors: Object<string, boolean>}}
 */
export const normaliseThirteenthMonthBasis = (stored) => ({
  factors: Object.fromEntries(
    Object.keys(DEFAULT_THIRTEENTH_MONTH_BASIS.factors).map((k) => [
      k,
      k === "basic"
        ? true
        : stored?.factors?.[k] === undefined
          ? DEFAULT_THIRTEENTH_MONTH_BASIS.factors[k]
          : Boolean(stored.factors[k]),
    ])
  ),
});
